<template>
  <div class="CardPictureSide-module--picture-side--1uLgW">

  </div>
<!--  <svg xmlns="http://www.w3.org/2000/svg" width="208" height="303">-->
<!--    <clipPath id="r">-->
<!--      <rect x=".5" y=".5" width="207" height="302" rx="8" />-->
<!--    </clipPath>-->
<!--    <g clip-path="url(#r)">-->
<!--      <path fill="#FFF" d="m0,0h208v303H0" />-->
<!--      <path-->
<!--        stroke="#176ee8"-->
<!--        stroke-width="430"-->
<!--        stroke-dasharray="3.67"-->
<!--        d="m0,294 306-303"-->
<!--      />-->
<!--    </g>-->
<!--  </svg>-->
</template>


<style>
.CardPictureSide-module--picture-side--1uLgW {
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-backface-visibility: hidden;
  overflow: hidden;
  background:
      linear-gradient(45deg, #3993ff 12%, transparent 0, transparent 88%, #3993ff 0),
      linear-gradient(135deg, transparent 37%, #1a7bf2 0, #1a7bf2 63%, transparent 0),
      linear-gradient(45deg, transparent 37%, #3993ff 0, #3993ff 63%, transparent 0),
      #ffffff;
  background-size: 17px 17px;
  border: 1px solid rgba(168, 174, 178, .4);
}
</style>